import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit, ApplicationRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatListModule } from '@angular/material';
import { AppConstants } from '../../shared/constants/constants';
import { Utility } from '../../common/utility';
import { RouterLink } from '@angular/router';
import { BaseService } from '../../shared/services/base.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit, OnDestroy, AfterViewInit {
  private isActiveNewsFeed = false;
  constructor(
      private router: Router,
      private baseService: BaseService
  ) {

  }

  ngOnInit(): void {
    this.isActiveNewsFeed = localStorage.getItem(AppConstants.localStorage.isActiveNewsFeed).toLowerCase() !== 'true' ? false : true;
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  onLogout() {
      this.baseService.logout();
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/components/menu/menu.component.ts